export const SITE_THIRD_PARTY_SENSORS_TABLE_FRENCH_LOCALE = {
  headers: {
    serialNumber: "Numéro de série",
    csId: "Cs Id",
    hwId: "Hardware Id",
    applianceCount: "Nombre d'appareils reliés",
    installationDate: "Date d'installation",
  },
  empty: "Aucun capteur tiers trouvé...",
};
